import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=27f42fbf&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=js&"
export * from "./Time.vue?vue&type=script&lang=js&"
import style0 from "./Time.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Time.vue?vue&type=style&index=1&id=27f42fbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f42fbf",
  null
  
)

/* custom blocks */
import block0 from "./Time.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports